// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__bO0j1","containerItemsCenter":"Skeleton_containerItemsCenter__Nl-hT"};